module.exports = __webpack_public_path__ + "static/media/0007.c6374a5d.jpg";